import { render, staticRenderFns } from "./opts-big-dialog.vue?vue&type=template&id=96eda31e"
import script from "./opts-big-dialog.vue?vue&type=script&lang=js"
export * from "./opts-big-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports